import { render, staticRenderFns } from "./EditScopes.vue?vue&type=template&id=3906a077&scoped=true"
import script from "./EditScopes.vue?vue&type=script&lang=js"
export * from "./EditScopes.vue?vue&type=script&lang=js"
import style0 from "../EditIsoTemplate.scss?vue&type=style&index=0&id=3906a077&prod&lang=scss&scoped=true&external"
import style1 from "../EditScopes.scss?vue&type=style&index=1&id=3906a077&prod&lang=scss&scoped=true&external"
import style2 from "./EditScopes.vue?vue&type=style&index=2&id=3906a077&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3906a077",
  null
  
)

export default component.exports